import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const FluidGradientEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const blobSize = 100
  const color0 = effectColors[0] || '#6366f1'
  const color1 = effectColors[1] || color0
  const color2 = effectColors[2] || color0

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {/* First blob */}
      <motion.div
        style={{
          position: 'absolute',
          width: 500 * (blobSize / 100),
          height: 500 * (blobSize / 100),
          background: `radial-gradient(circle, ${color0} 0%, transparent 70%)`,
          filter: 'blur(60px)',
          opacity: opacityValue,
          borderRadius: '50%',
        }}
        animate={{
          x: ['-25%', '75%', '-25%'],
          y: ['-25%', '50%', '-25%'],
        }}
        transition={{
          duration: 20 * (100 / Math.max(effectSpeed, 1)),
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      {/* Second blob */}
      <motion.div
        style={{
          position: 'absolute',
          width: 600 * (blobSize / 100),
          height: 600 * (blobSize / 100),
          background: `radial-gradient(circle, ${color1} 0%, transparent 70%)`,
          filter: 'blur(80px)',
          opacity: opacityValue,
          borderRadius: '50%',
        }}
        animate={{
          x: ['75%', '-25%', '75%'],
          y: ['50%', '-25%', '50%'],
        }}
        transition={{
          duration: 15 * (100 / Math.max(effectSpeed, 1)),
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      {/* Third blob */}
      <motion.div
        style={{
          position: 'absolute',
          width: 400 * (blobSize / 100),
          height: 400 * (blobSize / 100),
          background: `radial-gradient(circle, ${color2} 0%, transparent 70%)`,
          filter: 'blur(70px)',
          opacity: opacityValue,
          borderRadius: '50%',
        }}
        animate={{
          x: ['50%', '10%', '50%'],
          y: ['10%', '70%', '10%'],
        }}
        transition={{
          duration: 25 * (100 / Math.max(effectSpeed, 1)),
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </div>
  )
})
FluidGradientEffect.displayName = 'FluidGradientEffect'
